// libraries
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import {kebabCase} from 'lodash';

// shared
import {SPACE} from 'shared/keys';

class RadioButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {checked: !!this.props.selected};
  }

  static propTypes = {
    // will be an array if using an array to concatenate HTML elements and strings
    label: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.node]).isRequired,
    identifier: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    selected: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    legendText: PropTypes.string,
    required: PropTypes.bool,
    // Will deselect a currently selected radio button if value is true.
    allowDeselect: PropTypes.bool.isRequired,
    // Reference to the Redux Form field onChange function. Used for deselecting.
    onChange: PropTypes.func,
    error: PropTypes.bool
  };

  static defaultProps = {
    className: '',
    allowDeselect: false
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({checked: !!nextProps.selected});
  }

  labeledFor = () => {
    const {label, identifier, name} = this.props;

    return `${kebabCase(identifier || label)}-${name}-radio-input`;
  };

  handleClick = () => {
    const {allowDeselect} = this.props;

    if (!allowDeselect) {
      return;
    }

    if (this.state.checked) {
      this.deselect();
    }
  }

  deselect = () => {
    const {onChange} = this.props;
    onChange && onChange(null);
  }

  select = (value) => {
    const {onChange} = this.props;
    onChange && onChange(value);
  }

  handleKeyDown = (e) => {
    const key = e.which || e.keyCode;
    if (!this.props.allowDeselect || key !== SPACE) {
      return;
    }

    e.preventDefault();
    if (this.state.checked) {
      this.deselect();
    } else {
      this.select(e.currentTarget.value);
    }
  }

  render() {
    const {
      onSelect,
      label,
      className,
      disabled,
      value,
      name,
      required,
      error
    } = this.props;

    let inputProps = {};
    if (disabled) {
      inputProps['disabled'] = true;
      inputProps['aria-disabled'] = true;
    }
    inputProps['checked'] = this.state.checked;

    return (
      <label className={`radio-button ${className || ''}`} htmlFor={this.labeledFor()}>
        <input
          aria-labelledby={`${name}-legend ${this.labeledFor()}`}
          required={required}
          type="radio"
          name={name}
          onClick={this.handleClick}
          value={value}
          onChange={onSelect}
          onKeyDown={this.handleKeyDown}
          aria-checked={this.state.checked}
          id={this.labeledFor()}
          {...inputProps}
        />
        <span className={classnames('radio-button-label', {disabled, error})}>{label}</span>
      </label>
    );
  }
}

export default RadioButton;
